// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticlesContent_title__2gdES","articles":"ArticlesContent_articles__2Cl8s"};